/* eslint-disable */
import {
	useEffect, useMemo, useState
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import GrnTable from '@/Pages/GRNPage/GrnTable';
import Tab from '@/Components/InfoTab/tab';
import Info from '@/Components/InfoTab/Info';
import GrnHeader from '@/Pages/GRNPage/grnHeader';
import { urls } from '@/Constants';
import {
	inputHelper, isGstinDifferent, keyPressHandler, shipmentStatus, useProductData, useQuery
} from '@/Helpers';
import useKeyPress from '@/Helpers/useKeyPress';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import toast from 'react-hot-toast';
import { AlertModal } from '@/Components/Modals';
import { modalActions } from '@/Actions';
import DocumentsImagesSection from '../PurchaseOrderList/DocumnetSection';
import { DocumentModal } from '../PurchaseOrderList/docModal';
import { Download, Plus } from 'lucide-react';
import { FileUploaderModal } from '@/Components/Modals/FileUploaderModal';
import utilsServices from '@/Services/utilsServies.services';
import { notificationServices } from '@/Services';

const tabList = [
	{
		label: 'Shipment Products',
		value: 'shipmentProducts',
	},
	{
		label: 'Documents',
		value: 'documents',
	},
];

const fieldsMap = {
	'Shipment ID': 'id',
	'Deliver From': 'deliveryFrom',
	'Deliver To': 'deliveryTo',
	'Invoice Value + Charges': 'shipmentValue',
	'Client Po ID': 'clientPoId',
	'Shipment Type': 'type',
	'Vehicle Number': 'vehicleNumber',
	'Created On': 'createdAt',
	'Created By': 'createdBy',
	'Expected Dispatch Date': 'expectedDispatchDate',
	'Dispatch On': 'actualDispatchDate',
	'Expected Received Date': 'expectedReceivedDate',
	'Received On': 'actualReceivedDate',
};

function ShipmentDetails() {
	const query = useQuery();
	const history = useHistory();
	const id = query.get('id');
	const type = query.get('type');
	const shipmentList = useSelector((state) => state.analytics.INVENTORY_ANALYTICS.SHIPMENT_LIST);
	const keyPressed = useKeyPress();
	const [tabValue, setTabValue] = useState('shipmentProducts');
	const [po, setPo] = useState({});
	const [idx, setIdx] = useState(-1);
	const [shipmentData, setShipmentData] = useState({});
	const [data, setData] = useState([]);
	const [documents, setDocuments] = useState([]);
	const [shipmentInfo, setShipmentInfo] = useState({});
	const [downloadButton, setDownloadButton] = useState([]);
	const backUrl = history?.location?.state?.prevPath || urls.EXTENSION + urls.SHIPMENT_LIST;
	const formatDate = (date) => (date ? moment(date).format('Do MMMM YY') : 'N/A');
	const products = useSelector((state) => state.form.ALL_PRODUCTS.data?.LIST);
	const dispatch = useDispatch();
	useEffect(() => {
		if (Array.isArray(products) && products?.length === 0) {
			useProductData(dispatch);
			return;
		}
	}, []);

	useEffect(() => {
		if(id){
			useProductData(dispatch);
			return;
		}
	}, [])

	const fetchShipmentById = async () => {
		try {
			const res = await inventoryAnalyticsServices.getShipmentById({
				data: {
					shipmentId: id,
					base64: true,
				},
			});
			if (res?.statusCode === 200) {
				setShipmentData(res?.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		fetchShipmentById();
	}, [id]);

	const fetchpo = async () => {
		try {
			const response = await inventoryAnalyticsServices.fetchPo(shipmentData?.poId);
			if (response?.statusCode === 200) {
				setPo(response?.data);
			}
		} catch (error) {
			console.log(error);
		}
	};
	useEffect(() => {
		if (shipmentData?.poId) {
			fetchpo();
		}
	}, [shipmentData?.poId]);

	const handleShipmentValue = () => {
		const {
			deliveryPackagingCharges,
			totalAdditionalCharges,
		} = shipmentData?.chargesAndWorth?.sendingQty ?? {};
		const charges = deliveryPackagingCharges + totalAdditionalCharges;
		let rawQtyValue = Math.abs(shipmentData?.dispatchedValue - charges);
		if(['PACKAGING', 'DISPATCH']?.includes(shipmentData?.status)){
			rawQtyValue = 0;
		}
		return `₹${rawQtyValue?.toFixed(2)} + ₹${charges?.toFixed(2)}`;
	};

	useEffect(() => {
		setTabValue('shipmentProducts');
		setData(shipmentData?.items || []);
		setShipmentInfo({
			id: shipmentData?.id,
			clientShipmentId: shipmentData?.clientShipmentId,
			deliveryFrom: po?.fromStoreName || 'N/A',
			deliveryTo: (type === 'buyer' || po?.subType === 'BUYER') ? po?.vendorName : (po?.storeName || po?.vendorName || 'N/A'),
			clientPoId: po?.clientPoId || 'N/A',
			type: shipmentData?.shipmentType || 'N/A',
			vehicleNumber: shipmentData?.transVehicleNo || 'N/A',
			shipmentValue: handleShipmentValue() ?? 'N/A',
			createdBy: shipmentData?.initiatedByUserDisplayName || 'N/A',
			createdAt: formatDate(shipmentData?.createdAt),
			expectedDispatchDate: formatDate(shipmentData?.expectedDispatchDate) || 'N/A',
			actualDispatchDate: formatDate(shipmentData?.sendingDate) || 'N/A',
			expectedReceivedDate: formatDate(shipmentData?.expectedReceivedDate) || 'N/A',
			actualReceivedDate: formatDate(shipmentData?.receivingDate) || 'N/A',
		});
		if (shipmentList?.length > 0) {
			const currentIndex = shipmentList.findIndex(
				(item) => Number(item.id) === Number(id)
			);
			setIdx(currentIndex);
		}
	}, [shipmentData, shipmentList, po]);

	const navigateQc = (e) => {
		const { dataset } = inputHelper(e);
		let newListItem = null;

		if (dataset.type === 'next') {
			newListItem = shipmentList?.[idx + 1];
		} else {
			newListItem = shipmentList?.[idx - 1];
		}
		if (newListItem) {
			history.push({
				pathname: `${urls.EXTENSION}${urls.SHIPMENT_DETAILS}`,
				search: `id=${newListItem?.id}`,
				state: {
					prevPath: backUrl,
				},
			});
		}
	};

	useEffect(() => {
		const qcData = shipmentList?.[idx] ?? null;
		if (
			(keyPressed === 'ArrowLeft' || keyPressed === 'ArrowRight') &&
			qcData !== null
		) {
			const newListItem = keyPressHandler(
				keyPressed,
				shipmentList,
				idx
			);
			if (newListItem) {
				history.push({
					pathname: `${urls.EXTENSION}${urls.SHIPMENT_DETAILS}`,
					search: `id=${newListItem?.id}`,
					state: {
						prevPath: backUrl,
					},
				});
			}
		}
	}, [keyPressed]);


	const handleBuyerUploadedDoc = async() => {
		const docDbUrl = shipmentData?.extraData?.[0]?.jsonData?.buyerUploadedDoc?.doc_db_url;
		if (!docDbUrl) return null;

		try {
			const response = await utilsServices?.getBase64FromFileUrl({
				data: {
					docUrls: [docDbUrl],
				},
			});

			if (response?.statusCode === 200) {
				const base64url = response?.data?.[docDbUrl] ?? null;
				return {
					name: shipmentData?.extraData?.[0]?.jsonData?.buyerUploadedDoc?.fileName,
					type: '',
					uploadedDate: shipmentData?.extraData?.[0]?.jsonData?.buyerUploadedDoc?.uploadedAt,
					base64url,
					url: shipmentData?.extraData?.[0]?.jsonData?.buyerUploadedDoc?.url,
					podId: shipmentData?.extraData?.[0]?.jsonData?.buyerUploadedDoc?.podId,
					delete: true,
					id: shipmentData?.id,
				};
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
		return null;
	}
	const handleDocData = async() => {
		let docs = [];
		let docData = [];
		const uploadedDoc = await handleBuyerUploadedDoc();
		if (uploadedDoc) {
			docs.push(uploadedDoc);
		}
		docs.push(...(shipmentData?.docs?.map((doc) => {
				const name = doc?.docUrlDb?.split('/')?.splice?.(-1)?.toString() ?? '';
				return {
					name: name,
					type: doc?.docType?.toCapitalize?.() ?? '',
					uploadedDate: doc?.createdAt,
					base64url: doc?.docUrlBase64,
					url: doc?.docUrl,
				};
			}) || []));
		setDocuments(docs);
		const eInvoiceUrl = shipmentData?.extraData?.[0]?.jsonData?.eInvoice?.eInvoiceUrl;
		const eWayBillUrl = shipmentData?.extraData?.[0]?.jsonData?.ewayBill?.url;
		if(eInvoiceUrl){
			if(eWayBillUrl){
				docData.push({
					name: 'E-Invoice',
					url: eInvoiceUrl,
					icon: <Download size={16} />,
					style :'bg-slate-100 border-slate-500',
				});
			}else {
				docData?.push({
					name: 'E-Invoice',
					noButton: true,
					infoText: '*Generate E-way Bill to download Invoices',
					style: 'text-orange-500',
				})
			}
		}
		if(eWayBillUrl){
			docData.push({
				name: 'E-Way Bill',
				url: `https://${eWayBillUrl}`,
				icon: <Download size={16} />,
				style: 'bg-blue-100 border-blue-500',
			});
		}
		setDownloadButton(docData);
	}
	const handleTabChange = (value) => {
		setTabValue(value);
		if (value === 'documents') {
			handleDocData();
		}
	};


	const handleConfirm = async () => {
		try {
			const res = await inventoryAnalyticsServices.updateShipmentStatus({
				data: {
					shipmentId: id,
					status: 'CANCEL',
				},
			});
			if (res?.statusCode === 200) {
				toast.success('Shipment cancelled successfully');
				fetchShipmentById();
				dispatch(modalActions?.toggleAlert(false));
			}
		} catch (error) {
			toast.error('Something went wrong');
			console.log(error);
		}
	}

	const handleCancel = () => {
		dispatch(modalActions?.toggleAlert(true, {
			title: 'Cancel Shipment',
			message: 'Are you sure you want to cancel this shipment?',
			handleConfirm: handleConfirm
		}))
	};

	const handleCreateEInvoice = () => {
		const urlType = 'INVOICE';
		const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${po?.id}&shipmentId=${id}&type=${urlType}`;
		window.open(url, '_blank');
	}

	const handleCreateEWayBill = () => {
		const urlType = 'EWAYBILL';
		const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${po?.id}&shipmentId=${id}&type=${urlType}`;
		window.open(url, '_blank');
	}
	const handleEInvoice = () => {
		const url = shipmentData?.extraData?.[0]?.jsonData?.eInvoice?.eInvoiceUrl;
		window.open(url, '_blank');
	}
	const handleEWayBill = () => {
		const url = `https://${shipmentData?.extraData?.[0]?.jsonData?.ewayBill?.url}`;
		window.open(url, '_blank');
	}

	const handleOpenDocumentModal = () => {
		dispatch(modalActions.toggleFileUploaderModal(true, {
			heading: 'Upload Document',
			id: id,
			showInput: true,
			inputInfo: {
				label: 'POD ID',
				placeholder: 'Enter POD ID',
				mandatory: true,
			},
		}));
	}
	const handleDocUpload = async (file, id, podId) => {
		const req = {
			data: {
				shipmentId:id,
				id: po?.id,
				uploadDoc: file,
				podId: podId,
			}
		}
		try {
			const response = await inventoryAnalyticsServices.uploadDocument(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				dispatch(modalActions.toggleFileUploaderModal(false));
				fetchShipmentById();
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message,
			});
		}
	};

	const buttons = [
		{
			label: 'Upload POD Document',
			noLevelSpecific: true,
			handleClick: handleOpenDocumentModal,
			style: 'border border-blue-400 bg-transparent',
		},
		{
			label: 'Create E-Invoice',
			icon: <Plus size={16} />,
			noLevelSpecific: true,
			handleClick: handleCreateEInvoice,
			style: 'bg-blue-100 border-blue-500',
		},
		{
			label: 'Create E-Way Bill',
			icon: <Plus size={16} />,
			noLevelSpecific: true,
			handleClick: handleCreateEWayBill,
			style: 'bg-slate-100 border-slate-500',
		},
		{
			label: 'E-Invoice',
			icon: <Download size={16} />,
			level: true,
			noLevelSpecific: true,
			handleClick: handleEInvoice,
			style: 'bg-blue-100 border-blue-500',
		},
		{
			label: 'E-Way Bill',
			icon: <Download size={16} />,
			level: true,
			noLevelSpecific: true,
			handleClick: handleEWayBill,
			style: 'bg-slate-100 border-slate-500',
		},
		{
			label: 'Cancel',
			noLevelSpecific: true,
			handleClick: handleCancel,
			style: 'text-red-700 border-red-700',
		},
	];
	//  orderProducts Tab
	const SPECIAL_COLUMNS = [
		{
			title: 'Variant Name',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Unit',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Shipment Planned Quantity',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Dispatch Quantity',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Received Quantity',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Item Price',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Discount%',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Tax %',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Tax Value',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Planned Amount',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Dispatch Amount',
			config: {
				type: 'DATA',
			},
		}
	];

	const colMap = {
		'Variant Name': 'id',
		Unit: 'unit',
		'Shipment Planned Quantity': 'qty',
		'Returned Quantity': 'returnedQuantity',
		'Dispatch Quantity': 'sendingQty',
		'Item Price': 'productCost',
		'Discount%': 'discountPercentage',
		'Tax %': 'taxPercentage',
		'Tax Value': 'id',
		'Planned Amount': 'id',
		'Dispatch Amount': 'id',
		'Received Quantity': 'receivedQty',
	};

	const specialMappings = {
		'Variant Name': (id, val) => {
			const productId = data?.find((item) => Number(item.id) === Number(id))?.productId;
			const variantId = data?.find((item) => Number(item.id) === Number(id))?.variantId;
			const product = products?.find((item) => Number(item.id) === Number(productId))?.productName;
			const variant = products?.find((item) => Number(item.id) === Number(productId))?.variants?.find((item) => Number(item.id) === Number(variantId))?.displayName;
			return (
				<p className='text-[12px] text-nowrap text-left'>
					{product}
					{variant ? ` (${variant})` : ''}
				</p>
			);
		},
		Unit: (id, val) => {
			return <p className='text-[12px] text-nowrap text-left'>{val ?? 'N/A'}</p>;
		},
		'Shipment Planned Quantity': (id, val) => {
			return <p className='text-[12px] text-nowrap text-left'>{val ?? 'N/A'}</p>;
		},
		'Returned Quantity': (id, val) => {
			return <p className='text-[12px] text-nowrap text-left'>{val?.toFixed(2) ?? 'N/A'}</p>;
		},
		'Dispatch Quantity': (id, val) => {
			return <p className='text-[12px] text-nowrap text-left'>{val?.toFixed(2) ?? 'N/A'}</p>;
		},
		'Received Quantity': (id, val) => {
			return <p className='text-[12px] text-nowrap text-left'>{val?.toFixed(2) ?? 'N/A'}</p>;
		},
		'Item Price': (id, val) => {
			return <p className='text-[12px] text-nowrap text-left'>{`₹${val?.toFixed(2) ?? 'N/A'}`}</p>;
		},
		'Discount%': (id, val) => {
			return <p className='text-[12px] text-nowrap text-left'>{val ? `${val.toFixed(2)}%` : 'N/A'}</p>;
		},
		'Tax %': (id, val) => {
			return <p className='text-[12px] text-nowrap text-left'>{val ? `${val}%` : 'N/A'}</p>;
		},
		'Tax Value': (id, val) => {
			const item = shipmentData?.chargesAndWorth?.qty?.itemLevelCharges[val]?.item_qty_Tax;
			return <p className='text-[12px] text-nowrap text-left'>{`₹${item?.toFixed(2) ?? 'N/A'}`}</p>;
		},
		'Dispatch Amount': (id, val) => {
			const item = shipmentData?.chargesAndWorth?.sendingQty?.itemLevelCharges[val]?.item_sendingQty_FinalValue;
			return <p className='text-[12px] text-nowrap text-left'>{`₹${item?.toFixed(2) ?? 'N/A'}`}</p>;
		},
		'Planned Amount': (id, val) => {
			const item = shipmentData?.chargesAndWorth?.qty?.itemLevelCharges[val]?.item_qty_FinalValue;
			return <p className='text-[12px] text-nowrap text-left'>{`₹${item?.toFixed(2) ?? 'N/A'}`}</p>;
		},
	};
	const handleButtons = () => {
		const hasEWayBill = Boolean(shipmentData?.extraData?.[0]?.jsonData?.ewayBill?.url);
		const hasEInvoice = Boolean(shipmentData?.extraData?.[0]?.jsonData?.eInvoice?.eInvoiceUrl);
		const hasCancleButton = shipmentData?.items?.some((item) => item?.receivedQty === 0 && item?.sendingQty === 0) || shipmentData?.items?.length === 0;
		const shipmentStatus = shipmentData?.status;
		const excluded = ['PACKAGING', 'DISPATCH', 'CANCELLED', 'ABANDONED'];
		const result = [];
		const targetGstin = type === 'buyer' || po?.subType === 'BUYER' ? po?.vendorGstin : (po?.storeGstin ?? po?.vendorGstin);
		const differentGstIn = isGstinDifferent(po?.fromStoreGstin, targetGstin);
		const showUploadButton = shipmentData?.status === 'TRANSIT' && (type === 'buyer' || po?.subType === 'BUYER') && !shipmentData?.extraData?.[0]?.jsonData?.buyerUploadedDoc;
		if(showUploadButton){
			result.push(buttons?.find((b) => b?.label === 'Upload POD Document'));
		}
		if (hasCancleButton) {
			result.push(buttons?.find((b) => b?.label === 'Cancel'));
		}
		if (shipmentData?.status === 'TRANSIT' && !hasEWayBill && !po?.sameLocation) {
			result.push(buttons?.find((b) => b?.label === 'Create E-Way Bill'));
		}
		if (!hasEInvoice && shipmentStatus && !excluded.includes(shipmentStatus) && (differentGstIn || po.subType === 'BUYER')) {
			result.push(buttons?.find((b) => b?.label === 'Create E-Invoice'));
		}
		if(hasEWayBill){
			result.push(buttons?.find((b) => b?.label === 'E-Way Bill'));
		}
		if(hasEInvoice){
			if(hasEWayBill){
				result.push(buttons?.find((b) => b?.label === 'E-Invoice'));
			}else {
				result.push({
					label: 'E-Invoice',
					noButton: true,
					infoText: '*Generate E-way Bill to download Invoices',
					style: 'text-orange-500',
				});
			}
		}
		if(shipmentStatus === 'CANCELLED'){
			return [];
		}
		return result.filter(Boolean);
	}

	const handleDeleteDocument = async (id) => {
		const req = {
			data : {
				shipmentId: id,
			}
		}
		try{
			const response = await inventoryAnalyticsServices.deleteDocument(req)
			if(response?.statusCode === 200){
				notificationServices?.generateNotification({
					type: 'success',
					message: 'Document deleted successfully',	
				})
				dispatch(modalActions?.toggleAlert(false));
				dispatch(modalActions?.toggleDocumentModal(false));
				fetchShipmentById();
			}
		}catch(error){
			notificationServices?.generateNotification({
				type: 'error',
				message: error?.message || error,
			})
		}
	}

	const handleAlertModal = async (id) => {
		dispatch(modalActions?.toggleAlert(true, {
			heading: 'Delete Proof of delivery Document',
			message: `Are you sure you want to delete this document of this SO ID Shipment ${id}?`,
			handleConfirm: () => handleDeleteDocument(id),
		}));
	}
	const handleViewDoc = (document, documents) => {
		dispatch(modalActions?.toggleDocumentModal(true, { obj: document, list: documents, handleDelete: handleAlertModal }));
	};
	const handleRefresh = () => {
		fetchShipmentById();
		fetchpo();
	}
	return (
		<>
			<DocumentModal />
			<FileUploaderModal handleConfirm={handleDocUpload} />
			<GrnHeader
				url={backUrl}
				title='Back to Shipment Logs'
				navigateLabel='Shipment Id'
				id={id}
				navigatePrevToolTip='Prev Shipment'
				navigateNextToolTip='Next Shipment'
				navigateQC={navigateQc}
				listData={shipmentList}
				idx={idx}
				isRefresh={true}
				handleRefresh={handleRefresh}
			/>
			<AlertModal />
			<div className='relative top-[3rem] p-4'>
				<Info
					buttons={handleButtons()}
					fieldMap={fieldsMap}
					data={shipmentInfo}
					specialFields={{}}
					heading={
						{
							key: 'Shipment Status',
							value: shipmentStatus(shipmentData?.status),
						}
					}
				/>
				<Tab
					tabList={tabList}
					tabValue={tabValue}
					handleTabChange={handleTabChange}
				/>
				{tabValue === 'shipmentProducts' && (
					<GrnTable
						data={data}
						colMap={colMap}
						special={SPECIAL_COLUMNS}
						specialMappings={specialMappings}
						tableType='orderedProducts'
					/>
				)}
				{tabValue === 'documents' && (
					<DocumentsImagesSection
						documents={documents}
						handlePreview={handleViewDoc}
						downloadButton={downloadButton}
					/>
				)}
			</div>
		</>
	);
}

export default ShipmentDetails;
